import { render, staticRenderFns } from "./SecurityView.vue?vue&type=template&id=be02668e&scoped=true"
import script from "./SecurityView.vue?vue&type=script&lang=js"
export * from "./SecurityView.vue?vue&type=script&lang=js"
import style0 from "./SecurityView.vue?vue&type=style&index=0&id=be02668e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be02668e",
  null
  
)

export default component.exports